import { createStore } from 'owa-satcheljs';

export interface UndoStore {
    hasUndoableAction: boolean;
}

const undoStoreData = {
    hasUndoableAction: false,
};

export const getUndoStore: () => UndoStore = createStore<UndoStore>('undo', undoStoreData);
